import { EmailSequenceMap } from "schemas/dashboard";

import { BulkSendState } from "./schema";

export const buildInitialState = (
  emailSequences: EmailSequenceMap,
): BulkSendState => ({
  emailSequences: Object.values(emailSequences),
  fallbackTemplates: [],
});
